import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FlightOrderCard from "./FlightOrderCard/FlightOrderCard";
import "../index.css";

function AiriqFlightOrderCard({ order, ...props }) {
  const { flight_data } = order;

  function createUTCdateForISO(dateString) {
    const offset = new Date().getTimezoneOffset();
    const myDate = Date.parse(dateString) + offset * 60 * 1000;
    const dateAsISO = new Date(myDate).toISOString();

    return dateAsISO;
  }

  const flightOrder = order && {
    status: order.status.toUpperCase(),
    order_amount: order.order_amount,
    amount: order.amount,
    currency: order.vendorDetails.at(0).currency || "INR",
    booking_id: order?.booking_id,
    vendorDetails: order?.vendorDetails.at(0),
    createdAt: order?.createdAt,
    updatedAt: order?.updatedAt,
    flight_data: flight_data && {
      origin: order.fly_from,
      destination: order.fly_to,
      segments: [
        {
          airline: flight_data.flight_number?.split(" ")[0],
          local_departure:
            flight_data.departure_date &&
            flight_data.departure_time &&
            `${flight_data.departure_date}T${flight_data.departure_time}:00.000Z`,
          utc_departure:
            flight_data.departure_date &&
            flight_data.departure_time &&
            `${flight_data.departure_date}T${flight_data.departure_time}:00.000Z`,
          local_arrival:
            flight_data.arival_date &&
            flight_data.arival_time &&
            `${flight_data.arival_date}T${flight_data.arival_time}:00.000Z`,
          utc_arrival:
            flight_data.arival_date &&
            flight_data.arival_time &&
            `${flight_data.arival_date}T${flight_data.arival_time}:00.000Z`,
          flyFrom: order.fly_from,
          flyTo: order.fly_to,
          fare_category: "M",
          flight_no: flight_data.flight_number?.split(" ")?.at(-1),
        },
      ],
    },
    passenger_data: [
      ...(order.adult_info?.map((info) => ({
        title: info.title,
        name: info.first_name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category
      })) || []),
      ...(order.child_info?.map((info) => ({
        title: info.title,
        name: info.first_name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category
      })) || []),
      ...(order.infant_info?.map((info) => ({
        title: info.title,
        name: info.first_name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category
      })) || []),
    ],
  };

  return <FlightOrderCard props={props} order={flightOrder} />;
}
export default AiriqFlightOrderCard;
